export default "__VITE_ASSET__$LjoFaRg__"